import { render } from "./Login.vue?vue&type=template&id=589faa9a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=589faa9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-589faa9a"

export default script